import Button from '@mui/material/Button';
import { CloudUploadOutlined } from '@mui/icons-material';
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Tooltip } from '@mui/material';
import BulkQuestionsViaDocInput from './BulkQuestionsVIaDocInput';
import DocQuestionsPrev from './DocQuestionsPrev';
import { Download } from 'lucide-react';
import { useRecordContext } from 'react-admin';

function BulkUploadDialogViaDocFile({
    open,
    setOpen,
    path,
    setShowActions,
    sectionId,
}: {
    open: boolean;
    setOpen: any;
    path: any;
    setShowActions: any;
    sectionId: any;
}) {
    const [questionsList, setQuestionsList] = React.useState([]);
    const record = useRecordContext();

    const handleClose = () => {
        setOpen(false);
        setQuestionsList([]);
        setShowActions(false);
    };

    return (
        <>
            {questionsList?.length > 0 ? (
                <>
                    <DocQuestionsPrev
                        handleClose={handleClose}
                        questionsList={questionsList}
                        open={open}
                        path={path}
                        sectionId={sectionId}
                    />
                </>
            ) : (
                <Dialog open={open} onClose={handleClose}>
                    <div className="flex flex-row justify-between">
                        <DialogTitle>Bulk Upload Questions Via Doc</DialogTitle>
                        <DialogTitle>
                            <a
                                href="https://assets.kaksya.in/samples/test-doc-upload.docx"
                                download
                                className="flex gap-2 text-blue-900 cursor-pointer hover:underline"
                            >
                                <Download /> Sample
                            </a>
                        </DialogTitle>
                    </div>
                    <DialogContent className="">
                        <DialogContentText>
                            <BulkQuestionsViaDocInput
                                testId={record?.testId ?? record?.id}
                                questionsList={questionsList}
                                setQuestionsList={setQuestionsList}
                                onSuccess={(key: string) => {
                                    handleClose();
                                }}
                            />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

export const BulkUploadQuestionBankViaDocAction = ({ path, setShowActions, sectionId }: any) => {
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <BulkUploadDialogViaDocFile
                open={open}
                setOpen={setOpen}
                path={path}
                setShowActions={setShowActions}
                sectionId={sectionId}
            />
            <Tooltip title="Bulk Upload">
                <Button
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    <CloudUploadOutlined />
                    <span className="px-2">UPLOAD Via Doc (Beta)</span>
                </Button>
            </Tooltip>
        </>
    );
};
